import React, { useCallback, useEffect, useRef, useState } from "react";
import { CustomBreadcrumb } from "../../../shared/components/custom-breadcrumb/custom-breadcrumb";
import { CustomTable } from "../../../shared/components/custom-table/custom-table";
import { SERVICES } from "../../../core/services/services";
import "./merchant.css";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import { CustomModal } from "../../../shared/components/custom-modal/custom-modal";
import { DetailsBreakDown } from "../../../shared/components/details-break-down/details-break-down";
import { CustomConfirmDialog } from "../../../shared/components/custom-confirm-dialog/custom-confirm-dialog";
import { Toast } from "primereact/toast";
import { PaymentFacilitatorForm } from "./payment-facilitator-form";
import { HELPER } from "../../../shared/helper/helper";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { Optional } from "../../../shared/components/optional/optional";
import { PaymentFacilitatorsFilter } from "./payment-facilitators-filter";
import { BACKOFFICE_SERVICE } from "../../../core/services/backoffice-service";
import { BACKOFFICE_API } from "../../../core/apis/backoffice-apis";
import { BulkSuperAgentsCreationForm } from "./bulk-payment-facilitators-creation-form";

export function PaymentFacilitators() {
  const toast = useRef(null);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [error, setError] = useState("");
  const [search, setSearch] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  // const [modalLoadingText, setModalLoadingText] = useState("");
  const [confirmText, setConfirmText] = useState("");
  const [itemIdForDeactivation, setItemIdForDeactivation] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [range] = useState(5);
  const [confirmModalError, setConfirmModalError] = useState(null);
  const [confirmModalSuccess, setConfirmModalSuccess] = useState(null);
  const [breakDownTitle, setBreakDownTitle] = useState("");
  const [merchantForEdit, setMerchantForEdit] = useState(null);
  const [merchantSettlementData, setMerchantSettlementData] = useState(null);
  const [merchantAction, setMerchantAction] = useState("DEACTIVATE");
  const [emptyText, setEmptyText] = useState("");
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [pageNo, setPageNo] = useState(0);
  const [gettingMerchantDetails, setGettingMerchantDetails] = useState(false);
  const [searchParams, setSearchParams] = useState(null);

  const tableHeaders = [
    { label: "Name", value: "paymentFacilitatorName" },
    { label: "Id", value: "paymentFacilitatorId" },
    { label: "Email", value: "mainEmail" },
    { label: "Phone Number", value: "phoneNumber" },
    // { label: "Support Email", value: "supportEmail" },
    { label: "Status", value: "active" },
    { label: "Actions", value: "actions" },
  ];
  const merchantAuthorities = [
    { label: "UPDATE", value: "bo_dd_update_facilitator" },
    { label: "DEACTIVATE", value: "bo_dd_update_facilitator" },
    { label: "ACTIVATE", value: "bo_dd_update_facilitator" },
  ];

  const [details, setDetails] = useState([]);

  const [paymentFacilitators, setPaymentFacilitators] = useState([]);

  const openModal = useCallback((index, isMobile) => {
    setCurrentModalIndex(index);
    if (isMobile) {
      setCurrentIndex(2);
    } else {
      setVisible(true);
    }
  }, []);

  function deactivateUser(e) {
    setModalLoading(true);
    setConfirmModalError(null);
    setConfirmModalSuccess(null);
    const params = {
      id: e,
      status: merchantAction === "DEACTIVATE" ? false : true,
    };
    SERVICES.DEACTIVATE_MERCHANT(params)
      .then((data) => {
        setConfirmModalSuccess(
          `Payment facilitator ${merchantAction.toLowerCase()}d successfully`
        );
        setModalLoading(false);
      })
      .catch((error) => {
        setConfirmModalError(HELPER.PROCESS_ERROR(error));
        setModalLoading(false);
      });
  }

  const getMerchantDetails = useCallback(
    (id, isMobile) => {
      setGettingMerchantDetails(true);
      openModal(1, isMobile);
      let arr = [];
      setDetails([]);
      SERVICES.GET_MERCHANT(id)
        .then((data) => {
          const e = data.result;
          arr.push({
            label: "Payment Facilitator",
            value: e?.paymentFacilitatorName,
          });
          arr.push({ label: "email", value: e?.mainEmail });
          arr.push({ label: "Phone number", value: e?.phoneNumber });

          arr.push({
            label: "Support Email",
            value: e?.supportEmail,
          });
          arr.push({
            label: "Settlement Email",
            value: e?.settlementEmail,
          });
          arr.push({
            label: "Status",
            value: e?.active ? "Active" : "Inactive",
            itemCase: "active",
          });
          arr.push({
            label: "Dispute Email",
            value: e?.disputeEmail,
          });
          arr.push({ label: "Account name", value: e?.accountName });
          arr.push({
            label: "Account Number",
            value: e?.accountNumber,
          });
          arr.push({
            label: "Fee Type",
            value: e?.chargeTypeModel?.chargeTypeName,
          });
          arr.push({
            label: "Settlement Type",
            value: e?.settlementType,
          });

          arr.push({
            label: "Transit Account",
            value: e?.settlementTransitAccount?.accountNumber,
          });
          arr.push({
            label: "Transit Account Name",
            value: e?.settlementTransitAccount?.accountName,
          });
          setDetails(arr);
          setBreakDownTitle("Payment Facilitator");

          setGettingMerchantDetails(false);
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: HELPER.PROCESS_ERROR(error, "TOAST"),
            life: 10000,
          });
          setVisible(false);
        });
    },
    [openModal]
  );

  const deactivateMerchant = useCallback(
    (e, isMobile) => {
      setConfirmModalError(null);
      setConfirmModalSuccess(null);
      setModalLoading(true);
      openModal(3, isMobile);
      setItemIdForDeactivation(e?.paymentFacilitatorId);
      setConfirmText(`${e.paymentFacilitatorName?.toString()?.toLowerCase()}`);
      setModalLoading(false);
    },
    [openModal]
  );

  const getMerchantForEdit = useCallback(
    (id, isMobile) => {
      SERVICES.GET_MERCHANT(id)
        .then((data) => {
          const e = data.result;
          const updateData = {
            disputeEmail: e?.disputeEmail,
            mainEmail: e?.mainEmail,
            paymentFacilitatorId: e?.paymentFacilitatorId,
            paymentFacilitatorName: e?.paymentFacilitatorName,
            phoneNumber: e?.phoneNumber,
            settlementEmail: e?.settlementEmail,
            supportEmail: e.supportEmail,
          };
          let participants = e?.settlementParticipants.map((participant) => {
            return {
              desc: participant.participantId,
              code: participant.name,
              id: participant.participantId,
            };
          });
          const settlementData = {
            chargeType: {
              desc: e?.chargeTypeModel.chargeTypeName,
              code: e?.chargeTypeModel.code,
            },
            accountNumber: e?.accountNumber,
            accountName: e?.accountName,
            participants: participants,
            settlementType: {
              code: e?.settlementType,
              decs: e?.settlementType,
            },
            paymentFacilitatorId: e?.paymentFacilitatorId,

            settlementTransitAccountReference:
              e?.settlementTransitAccount?.accountReference,
          };
          setMerchantForEdit(updateData);
          setMerchantSettlementData(settlementData);
          openModal(2, isMobile);
        })
        .catch((error) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: HELPER.PROCESS_ERROR(error, "TOAST"),
            life: 10000,
          });
        });
    },
    [openModal]
  );

  const openAction = useCallback(
    (e, action, isMobile) => {
      // eslint-disable-next-line default-case
      setMerchantAction(action);
      switch (action) {
        case "VIEW":
          getMerchantDetails(e?.paymentFacilitatorId, isMobile);
          break;
        case "UPDATE":
          getMerchantForEdit(e?.paymentFacilitatorId, isMobile);
          break;
        case "DEACTIVATE":
          deactivateMerchant(e, isMobile);
          break;
        case "ACTIVATE":
          deactivateMerchant(e, isMobile);
          break;
        default:
          return <div></div>;
      }
    },
    [getMerchantDetails, getMerchantForEdit, deactivateMerchant]
  );

  const handleSuccess = useCallback(
    (data) => {
      const result = data?.result?.content;
      if (!result?.length) {
        setEmptyText("No payment facilitator found...");
      } else {
        let arr = [];
        setTotalItems(data?.result?.totalElements);
        setTotalPages(data?.result.totalPages);
        result.forEach((e) => {
          arr.push({
            ...e,
            active: e?.active ? "Active" : "Inactive",
            actions: e?.active ? "CRUDE" : "CRUA",
            detailsFunction: openAction,
          });
        });
        setPaymentFacilitators(arr);
      }
      setError(null);
      setCurrentIndex(1);
      setLoading(false);
    },
    [openAction]
  );

  const handleError = useCallback((error) => {
    setError(HELPER.PROCESS_ERROR(error));
    setCurrentIndex(1);
    setLoading(false);
  }, []);

  const getMerchants = useCallback(() => {
    setCurrentIndex(0);
    setPaymentFacilitators([]);
    let params = {
      page: pageNo,
      size: 10,
    };
    params = HELPER.TO_URL_STRING(params);
    SERVICES.GET_MERCHANTS(params)
      .then((data) => {
        handleSuccess(data);
      })
      .catch((error) => {
        handleError(error);
      });
  }, [pageNo, handleSuccess, handleError]);

  useEffect(() => {
    if (!searchParams) {
      getMerchants();
    }
  }, [getMerchants, searchParams]);

  const getFilteredMerchants = useCallback(() => {
    setCurrentIndex(0);
    setPaymentFacilitators([]);
    setSearch(true);
    const queryParams = HELPER.TO_URL_STRING({
      page: pageNo,
      size: 10,
    });
    BACKOFFICE_SERVICE.MAKE_PUT_REQUEST(
      BACKOFFICE_API.GET_FILTERED_MERCHANTS,
      searchParams,
      queryParams
    )
      .then((data) => {
        handleSuccess(data);
      })
      .catch((error) => {
        handleError(error);
      });
  }, [searchParams, pageNo, handleSuccess, handleError]);

  useEffect(() => {
    if (searchParams) {
      getFilteredMerchants();
    }
  }, [getFilteredMerchants, searchParams]);

  function onHide() {}

  function reload() {
    setLoading(true);
    setSearch(false);
    setCurrentIndex(0);
    setSearchParams(null);
    getMerchants();
  }

  function goToPage(pageNo) {
    setPageNo(pageNo);
  }

  function closeModal(isReload) {
    if (visible) {
      setVisible(false);
    }
    if (currentIndex === 2) {
      setCurrentIndex(1);
    }

    if (isReload === true) {
      reload();
    }
  }

  function saveFilters(filters) {
    closeModal();
    setPageNo(0);
    setSearchParams(filters);
  }

  const superAgentsView = () => {
    // eslint-disable-next-line default-case
    switch (currentIndex) {
      case 0:
        return (
          <div className="loading-container">
            <CustomLoader loadingText="Loading payment facilitators..." />
          </div>
        );
      case 1:
        return (
          <CustomTable
            authorities={merchantAuthorities}
            totalPages={totalPages}
            totalItems={totalItems}
            currentPage={pageNo + 1}
            range={range}
            emptyText={emptyText}
            search={search}
            isReload={true}
            reload={reload}
            error={error}
            items={paymentFacilitators}
            headers={tableHeaders}
            nextPage={() => setPageNo(pageNo + 1)}
            prevPage={() => setPageNo(pageNo - 1)}
            goToFirstPage={() => setPageNo(0)}
            goToLastPage={() => setPageNo(totalPages - 1)}
            goToPage={goToPage}
          />
        );
      case 2:
        return (
          <div className="mobile-modal-container">
            <div className="custom-card">
              <div className="mobile-card-position">{mobileModal()}</div>
            </div>
          </div>
        );
    }
  };

  const modalContent = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return <PaymentFacilitatorForm closeModal={closeModal} />;
      case 1:
        return (
          <DetailsBreakDown
            title={breakDownTitle}
            breakDown={details}
            closeModal={closeModal}
            loading={gettingMerchantDetails}
          />
        );
      case 2:
        return (
          <PaymentFacilitatorForm
            editMerchant={merchantForEdit}
            merchantSettlementData={merchantSettlementData}
            isUpdate={true}
            closeModal={closeModal}
          />
        );
      case 3:
        return (
          <CustomConfirmDialog
            deactivate={merchantAction}
            success={confirmModalSuccess}
            toastError={confirmModalError}
            itemId={itemIdForDeactivation}
            confirmText={confirmText}
            loading={modalLoading}
            loadingText={
              merchantAction === "DEACTIVATE"
                ? "Deactivating payment facilitator..."
                : "Activating payment facilitator..."
            }
            fn={deactivateUser}
            closeModal={closeModal}
          />
        );
      case 4:
        return (
          <PaymentFacilitatorsFilter
            closeModal={closeModal}
            searchFunction={saveFilters}
          />
        );
      case 5:
        return <BulkSuperAgentsCreationForm closeModal={closeModal} />;
    }
  };

  const mobileModal = () => {
    // eslint-disable-next-line default-case
    switch (currentModalIndex) {
      case 0:
        return <PaymentFacilitatorForm closeModal={closeModal} />;
      case 1:
        return (
          <DetailsBreakDown
            title={breakDownTitle}
            breakDown={details}
            closeModal={closeModal}
            loading={gettingMerchantDetails}
          />
        );
      case 2:
        return (
          <PaymentFacilitatorForm
            editMerchant={merchantForEdit}
            merchantSettlementData={merchantSettlementData}
            isUpdate={true}
            closeModal={closeModal}
          />
        );
      case 3:
        return (
          <CustomConfirmDialog
            deactivate={merchantAction}
            success={confirmModalSuccess}
            toastError={confirmModalError}
            itemId={itemIdForDeactivation}
            confirmText={confirmText}
            loading={modalLoading}
            loadingText={
              merchantAction === "DEACTIVATE"
                ? "Deactivating payment facilitator..."
                : "Activating payment facilitator..."
            }
            fn={deactivateUser}
            closeModal={closeModal}
          />
        );
      case 4:
        return (
          <PaymentFacilitatorsFilter
            closeModal={closeModal}
            searchFunction={saveFilters}
          />
        );
      case 5:
        return <BulkSuperAgentsCreationForm closeModal={closeModal} />;
    }
  };

  return (
    <ErrorBoundary>
      <div className="super-agents">
        <Toast ref={toast} />
        <div>
          <CustomModal
            closeModal={closeModal}
            onHide={onHide}
            visible={visible}
            modalContent={modalContent}
          />
        </div>
        <div className="page-title p-text-left">Payment Facilitators</div>
        <div className="p-mt-2">
          <CustomBreadcrumb page="Manage Payment Facilitators" />
        </div>
        <div className="floating-buttons desktop-scree">
          <div className="p-grid">
            <div className="p-col-6"></div>
            <div className="p-col-6">
              <div className="p-grid">
                <div className="p-col-2"></div>
                <div className="p-col-3">
                  <button
                    disabled={loading}
                    onClick={() => openModal(4, false)}
                    className="filter-button"
                  >
                    <i className="pi pi-filter" />
                    <span className="hide-btn-text"> Filter</span>
                  </button>
                </div>
                {/* <div className="p-col-5">
                  <Optional
                    show={HELPER.HAS_AUTHORITY("bo_dd_create_facilitator")}
                  >
                    <button
                      disabled={loading}
                      onClick={() => openModal(5, false)}
                      className="tertiary-button hide-btn-text text-small"
                    >
                      <i
                        className="pi pi-plus"
                        style={{ fontSize: "0.8rem" }}
                      />{" "}
                      <span className="hide-btn-text">
                        Bulk Payment Facilitator Creation
                      </span>
                    </button>
                  </Optional>
                </div> */}
                <div className="p-col-7">
                  <Optional
                    show={HELPER.HAS_AUTHORITY("bo_dd_create_facilitator")}
                  >
                    <button
                      disabled={loading}
                      onClick={() => openModal(0, false)}
                      className="primary-button hide-btn-text"
                      style={
                        {
                          // fontSize: "0.8rem",
                        }
                      }
                    >
                      <i className="pi pi-plus" />
                      <span className="hide-btn-text">
                        {" "}
                        New Payment Facilitator
                      </span>
                    </button>
                  </Optional>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Optional show={HELPER.HAS_AUTHORITY("bo_dd_get_facilitators")}>
          <div className="p-mt-4">{superAgentsView()}</div>
        </Optional>
      </div>
    </ErrorBoundary>
  );
}
